module.exports = __webpack_public_path__ + "static/how-to-pay-3-790b67de147f96be7e6486b5ff49e205.png";